import { render, staticRenderFns } from "./ConfigListItem.vue?vue&type=template&id=ed37d862&scoped=true&"
import script from "./ConfigListItem.vue?vue&type=script&lang=js&"
export * from "./ConfigListItem.vue?vue&type=script&lang=js&"
import style0 from "./ConfigListItem.vue?vue&type=style&index=0&id=ed37d862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed37d862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed37d862')) {
      api.createRecord('ed37d862', component.options)
    } else {
      api.reload('ed37d862', component.options)
    }
    module.hot.accept("./ConfigListItem.vue?vue&type=template&id=ed37d862&scoped=true&", function () {
      api.rerender('ed37d862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/ConfigListItem.vue"
export default component.exports